import React from 'react';
import PropTypes from 'prop-types';
// import ImmutablePropTypes from 'react-immutable-proptypes';

import styles from './style.module.scss';
// import c from './img/newcards/'
export default class Card extends React.Component {

    static propTypes = {
        number: PropTypes.string,
        color: PropTypes.string,
        shape: PropTypes.string,
        shading: PropTypes.string,
        index: PropTypes.number,
        isClicked: PropTypes.bool,

        onClick: PropTypes.func.isRequired,

    }

    clickHandler = (e) => {

        this.props.onClick(this.props.number, this.props.color, this.props.shape, this.props.shading, this.props.index);
    }

    render() {
        let src = ""
        if (this.props.number === undefined || this.props.color === undefined || this.props.shape === undefined || this.props.shading === undefined) {
            src = `img/newcards/set.gif`
        } else {
            src = `img/newcards/${this.props.number}-${this.props.color}-${this.props.shape}-${this.props.shading}.gif`
        }

        if (this.props.isClicked) {
            return (
                <img className={styles.box}
                    alt="card"
                    src={src}
                    onClick={this.clickHandler}
                >
                </img>
            )
        }
        else {
            return (
                <img className={styles.box_unclicked}
                    alt="card"
                    src={src}
                    onClick={this.clickHandler}
                >
                </img>
            )
        }



    }
}
